import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import CookieNotice from "@/components/CookieNotice";
import Home from "@/pages/Home";
import Gartenservice from "@/pages/Gartenservice";
import Hausmeisterservice from "@/pages/Hausmeisterservice";
import Auszugsreinigung from "@/pages/Auszugsreinigung";
import Winterdienst from "@/pages/Winterdienst";
import WeitereLeistungen from "@/pages/WeitereLeistungen";
import UeberUns from "@/pages/UeberUns";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pb-16 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gartenservice" element={<Gartenservice />} />
            <Route path="/hausmeisterservice" element={<Hausmeisterservice />} />
            <Route path="/auszugsreinigung" element={<Auszugsreinigung />} />
            <Route path="/winterdienst" element={<Winterdienst />} />
            <Route path="/weitere-leistungen" element={<WeitereLeistungen />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </main>
        <Footer />
        <MobileCTA />
        <CookieNotice />
      </BrowserRouter>
    </div>
  );
}

export default App;
